<template>
  <div class="step_1">
    <div class="title" :class="{ active: activity == 1 || activity == 2 }">
      <div class="num">1</div>
      <div class="word">{{$vi18n('$i18n# 验证身份 #i18n$')}}</div>
    </div>
    <div class="border"></div>
    <div class="title" :class="{ active: activity == 2 }">
      <div class="num">2</div>
      <div class="word">{{$vi18n('$i18n# 设置新邮箱 #i18n$')}}</div>
    </div>
    <div class="border"></div>
    <div class="title">
      <div class="num">3</div>
      <div class="word">{{$vi18n('$i18n# 修改成功 #i18n$')}}</div>
    </div>
  </div>
</template>

<script lang="js">
export default {
	name: 'step',
	props: {
		activity: {
			type: Number,
			default: 1
		}
	},
};
</script>

<style lang="scss" scoped>
.step_1 {
  display: flex;

  .title {
    display: flex;
    height: 24px;

    .num {
      width: 16px;
      height: 16px;
      background: rgba(255, 255, 255, 1);
      border: 2px solid rgba(140, 140, 140, 1);
      border-radius: 50%;
      font-size: 12px;
      line-height: 16px;
      color: rgba(140, 140, 140, 1);
      text-align: center;
    }

    .word {
      color: rgba(140, 140, 140, 1);
      height: 20px;
      line-height: 20px;
      margin-left: 16px;
      width: auto;
    }
  }

  .active {
    .num {
      border: 2px solid rgba(253, 155, 33, 1);
      color: rgba(253, 155, 33, 1);
    }

    .word {
      color: rgba(253, 155, 33, 1);
    }
  }

  .border {
    width: 54px;
    height: 1px;
    background: rgba(217, 217, 217, 1);
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
  }
}
</style>
